export default {
  "404.title": "404 Not Found",
  "404.description": "404 Not Found",
  "404.message1": "The page you were looking for could not be found.",
  "404.message2": "Please search from the top page.",
  "404.backToTop": "back to the top page",
};
